/**
 * API URL Resolution Utility
 * Dynamically determines the correct Cloud Functions endpoint based on Firebase project ID
 */

/**
 * Get the correct Cloud Functions base URL based on the Firebase project ID
 * This ensures that API calls go to the correct environment regardless of which
 * hosting environment the app is deployed to
 */
export function getApiUrl(): string {
  const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;
  
  // Map project IDs to their Cloud Functions endpoints
  if (projectId === 'un-dollar-rentflow-dev') {
    return 'https://us-central1-un-dollar-rentflow-dev.cloudfunctions.net';
  } else if (projectId === 'un-dollar-rentflow-staging') {
    return 'https://us-central1-un-dollar-rentflow-staging.cloudfunctions.net';
  } else if (projectId === 'un-dollar-rentflow-prod') {
    return 'https://us-central1-un-dollar-rentflow-prod.cloudfunctions.net';
  }
  
  // Fallback to environment variable (remove /api suffix if present)
  const fallback = import.meta.env.VITE_API_URL || 'https://us-central1-un-dollar-rentflow-dev.cloudfunctions.net';
  return fallback.replace('/api', '');
}
